import { reviewTextParts, type ReviewReference } from "../lib/reviewReferences";

export default function ReviewText({ text, references }: { text: string; references: ReviewReference[] }) {
  return <>{reviewTextParts(text, references).map((part, index) => part.reference
    ? <span className="reviewReference" key={index}>{part.text}</span>
    : <span key={index}>{part.text}</span>)}</>;
}
